import { observer } from 'mobx-react';
import React from 'react';

import useStyles from './styles';

interface Props {
    title: React.ReactNode;
    description: React.ReactNode;
    action: React.ReactNode;
    className?: string;
}

const GenerationLauncher: React.FC<Props> = ({ title, description, action, className }) => {
    const { classes, cx } = useStyles();

    return (
        <div className={cx(classes.root, className)}>
            <div className={classes.text}>
                <p className={classes.title}>{title}</p>
                <p className={classes.description}>{description}</p>
            </div>
            {action}
        </div>
    );
};

export default observer(GenerationLauncher);
